<template lang="html">
  <div style="font-size:170%">
    <div class="text-center">
      <img src="/immagini/logo.png" style="height: 120px; margin: 20px 0 0">
    </div>
    <div class="step" v-if="step==1">
      <h1>Benvenuto in {{ $store.config.NAME }}</h1>
      <br>
      <br>
      Effettueremo adesso alcuni passaggi per inizializzare il centro
      <br>
      <br>
      <br>
      <Button type="primary" @click="step++">Avanti</Button>
    </div>

    <div class="step" v-if="step==2">
      <h1>Dati aziendali</h1>
      <br>
      <br>
      <Card style="max-width: 400px; margin: 0 auto;">
        <settings @saved="step++" :size="100"/>
      </Card>
    </div>

    <div class="step" v-if="step==3">
      <h1>Banca principale</h1>
      <br>
      <br>
      <Card style="max-width: 400px; margin: 0 auto;">
        <div v-if="!form_banca">
          Errore nel caricamento dei conti, ricaricare la pagina
        </div>
        <Form v-else :label-width="100">
          <FormItem label="Nome Banca">
            <Input v-model="form_banca.name"/>
          </FormItem>
          <FormItem label="Descrizione e IBAN">
            <Input v-model="form_banca.description"/>
          </FormItem>
          <FormItem>
            <Button @click="saveBanca()" :loading="loading_banca">Salva</Button>
          </FormItem>
        </Form>
      </Card>
    </div>

    <div class="step" v-if="step==4">
      <h1>Tessera soci predefinita</h1>
      <br>
      <br>
      <Card style="max-width: 400px; margin: 0 auto;">
        <cardForm @close="step++" :size="100"/>
      </Card>
    </div>

    <div class="step" v-if="step==5">
      <h1>Configurazione completata</h1>
      <br>
      <br>
      <div style="max-width: 600px; margin: 0 auto">
        <p>Hai completato la fase di configurazione dell'azienda!</p>
        <!--<p style="margin-top: 30px;">Se fai già uso del gestionale Bartolomeo, puoi <a @click="finish('/importazione')">cliccare qui</a> per procedere all'importazione dei dati</p>-->
        <p style="margin-top: 30px;">Puoi iniziare a usare il gestionale <a @click="finish('/')">cliccando qui</a></p>
      </div>
    </div>

  </div>
</template>

<script>
import settings from './settings-company'
import cardForm from './soci/card-form'
export default {
  components: {
    settings,
    cardForm,
  },

  store: {
    c: 'company',
    u: 'session.user',
  },
  data () {
    return {
      step: 1,
      form_banca: null,
      loading_banca: false,
    }
  },
  mounted () {
    this.$http.get('ledgers?company_id='+this.c.id).then(res => {
      this.form_banca = res.data.find(e => {
        return e.code.match(/^B/)
      })
    })
  },
  methods: {
    saveBanca () {
      this.loading_banca = true
      this.$http.post('ledgers', this.form_banca).then(res => {
        this.$root.$emit('ledgers')
        this.$Message.success('Salvato')
        this.step++
      }).finally(res => {this.loading_banca = false})
    },

    finish (route) {
      var c = require('lodash').clone(this.c)
      c.is_initialized = true
      this.$http.post("companies", c).then(res => {
        this.$set(this.$store, 'company', res.data)
        this.$router.push(route)
      })
    }
  }
}
</script>

<style lang="css">
.step {
  text-align: center;
  margin: 0 0 50px;
}
</style>
